import React from "react";

/**
 * Overlay fullscreen com fundo escurecido — bloqueia cliques enquanto processa.
 */
export default function LoadingOverlay({
  aberto = false,
  mensagem = "Processando…",
  zIndex = 2400,
}) {
  if (!aberto) return null;

  return (
    <div
      className="fz-loading-overlay"
      style={{ zIndex }}
      role="alertdialog"
      aria-busy="true"
      aria-live="assertive"
      aria-label={mensagem}
    >
      <div className="fz-loading-overlay__panel">
        <span className="fz-loading-overlay__spinner" aria-hidden="true" />
        <span className="fz-loading-overlay__text">{mensagem}</span>
      </div>
    </div>
  );
}
